/* @flow */

import { List } from 'immutable'
import { hot } from 'react-hot-loader/root'
import WizardLib from 'atpjs/wizard/wizard'
import CancelablePromise from 'atpjs/cancelable_promise'
import i18n from 'atpjs/helpers/i18n'
import { toSnakeCase } from 'atpjs/helpers/string'
import steps from 'tve/views/steps'
import OtpStep from 'tve/views/otp'
import LoadingStep from 'tve/views/loading'
import ErrorStep from 'tve/views/error'
import { getLead, pushLead, otpGenerate, otpVerify, loadTopics } from 'tve/api/atp'
import locales from 'tve/translations'

import type { StepListType } from 'atpjs/wizard/current_step'
import type { IdType } from 'atpjs/wizard/wizard'
import type { DataType } from 'atpjs/data_handler'

i18n.locales = locales

class Wizard extends WizardLib {
  static wizard: string = 'tve'
  static otpStep = OtpStep
  static loadingStep = LoadingStep
  static errorStep = ErrorStep
  static urlIdParam = 'tve_id'
  static usedUrlParams: { hash: Array<string>, search: Array<string> } = {
    hash: [],
    search: ['tve_id']
  }

  constructor(props) {
    super(props)
    const { data } = props

    const params = this.getUrlParams()
    if (params.locale) {
      i18n.locale = params.locale
      data.set('locale', i18n.locale)
    }

    this.state = {
      topics: List(),
      otpData: {},
      loading: true
    }
  }

  componentDidMount() {
    super.componentDidMount()
    const params = this.getUrlParams()
    loadTopics().then(() => {
      if (params[this.constructor.urlIdParam] || params.id) {
        this.loadData(params[this.constructor.urlIdParam] || params.id)
      } else {
        this.setState({ loading: false })
      }
    })
  }

  steps(): StepListType {
    const { data } = this.props
    return steps(data)
  }

  unauthorized(id) {
    return new CancelablePromise((resolve) => {
      this.props.data.set('id', id)
      return this.setState(
        {
          otpData: {},
          otp: true,
          loading: false
        },
        resolve
      )
    })
  }

  dataHandler = (data: mixed): mixed => {
    return { ...data, step: toSnakeCase(this.step) }
  }

  updateDataPromise(id, serverData) {
    return pushLead(id, serverData, this.dataHandler)
  }

  loadDataPromise(id: IdType): CancelablePromise {
    return getLead(id)
  }

  sendOtpPromise(id: IdType): CancelablePromise {
    return otpGenerate(id)
  }

  verifyOtpPromise(id: IdType, pin: string): CancelablePromise {
    return otpVerify(id, pin)
  }

  canChangeStep() {
    return true
  }

  correctStep(data: DataType, params: Object) {
    if (params.step) {
      return params.step
    } else if (data.get('rejectedAt')) {
      return 'cancelled'
    } else if (data.get('acceptedAt')) {
      return 'confirmation'
    } else {
      return super.correctStep(data, params)
    }
  }
}

export default hot(Wizard)
